<template>
  <div class="unit-items">
    <div class="unit-title">
      <h3 class="font-weight-regular mb-0 black--text">{{ title }}</h3>
      <v-btn @click="add" class="ma-1 white" fab small light>
        <v-icon>mdi-plus</v-icon></v-btn
      >
    </div>

    <draggable
      class="inner mt-5"
      :list="items"
      group="order"
      @start="startDrag()"
      @end="endDrag()"
      :ref="name"
      :id="name"
    >
      <div
        v-for="(item, index) in items"
        :key="`unit-${index}`"
        class="item mb-5 pa-4"
        :data-id="`${Math.round(new Date().getTime() / 1000)}`"
      >
        <div class="d-flex flex-row justify-space-between align-start">
          <v-row>
            <v-col cols="2">
              <div
                class="status-circle"
                :class="`status-circle--${item.color}`"
              >
                <span v-if="item.color === 'amber'">AMBER</span>
                <span v-if="item.color === 'green'">GREEN</span>
                <span v-if="item.color === 'red'">RED</span>
              </div></v-col
            >
            <v-col cols="10">
              <v-row>
                <v-col cols="4">
                  <h2 class="text-h2 grey--text text--darken-2  mb-8">
                    Saying
                  </h2>
                  <div
                    class="white--text text-h5 mb-4"
                    v-text="item.saying"
                  ></div>
                  <div
                    class="white--text text-p"
                    v-text="item.description"
                  ></div>
                </v-col>
                <v-col cols="4">
                  <h2 class="text-h2 grey--text text--darken-2 mb-8">Doing</h2>
                  <ul class="">
                    <li
                      class="white--text mb-4"
                      v-for="(sub, count) in item.doing"
                      :key="`doing-${index}-${count}`"
                    >
                      {{ sub }}
                    </li>
                  </ul>
                </v-col>
                <v-col cols="4">
                  <h2 class="text-h2 grey--text text--darken-2  mb-8">
                    Actions
                  </h2>
                  <ul class="">
                    <li
                      v-for="(sub, count) in item.actions"
                      :key="`actions-${index}-${count}`"
                      class="white--text mb-4"
                    >
                      {{ sub }}
                    </li>
                  </ul>
                </v-col></v-row
              >
            </v-col>
          </v-row>

          <div class="icons pa-1">
            <v-icon @click="edit(item)" class="white--text">mdi-pencil</v-icon>
            <v-icon @click="remove(item)" class="white--text"
              >mdi-delete-forever</v-icon
            >
          </div>
        </div>
      </div>
    </draggable>

    <v-dialog v-model="dialog">
      <!-- Delete  -->

      <v-card light v-if="dialogMode == 'remove'">
        <v-card-title>
          Are you sure you want to remove this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeCommit"
            >Delete</v-btn
          >
          <v-btn
            light
            color="white"
            class="mt-10 mt-2 mr-2"
            @click="closeDialog"
            >Close</v-btn
          >
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'edit'">
        <say-edit :doc="activeCard" @editCommit="editCommit">
          <v-btn
            light
            color="white"
            class="mt-10 mt-2 mr-2"
            @click="closeDialog"
            >Close</v-btn
          >
        </say-edit>
      </v-card>

      <v-card light v-if="dialogMode == 'add'">
        <say-add title="Add an item" :doc="item" @addCommit="addCommit">
          <v-btn
            light
            color="white"
            class="mt-10 mt-2 mr-2"
            @click="closeDialog"
            >Close</v-btn
          >
        </say-add>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
import SayAdd from "@/views/user/exercises/say/SayAdd";
import SayEdit from "@/views/user/exercises/say/SayEdit";

var defaults = {
  saying: "",
  description: "",
  doing: [],
  actions: [],
  color: "--amber",
};
export default {
  name: "SayArea",
  data() {
    return {
      items: this.value,
      item: {
        saying: "",
        description: "",
        doing: [],
        actions: [],
      },
      currIndex: null,
      refs: null,
      fields: [],
      dialogMode: "",
      activeCard: null,
      editMode: false,
      editIndex: null,
      deleteMode: false,
      deleteId: null,
      dialog: false,
      counter: 0,
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
  },
  components: {
    draggable,
    SayAdd,
    SayEdit,
  },
  watch: {
    value: {
      handler: function(val) {
        // console.log("input value updated", val);
        this.items = val;
      },
      deep: true,
    },
    items: {
      handler: function(val) {
        // console.log("emit value changed", val);
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    add() {
      this.item = defaults;
      this.dialogMode = "add";
      this.dialog = true;
    },
    addCommit($event) {
      let item = {
        index: this.items.length,
        id: new Date().valueOf(),
        ...$event,
      };
      this.items.push(item);
      this.closeDialog();
      this.$emit("autosave");
    },
    remove($event) {
      this.activeCard = $event;
      this.dialogMode = "remove";
      this.dialog = true;
    },
    removeCommit() {
      let items = this.items;
      let item = items.find((x) => x.id === this.activeCard.id);
      let indexOfItem = items.indexOf(item);
      items.splice(indexOfItem, 1);
      this.closeDialog();
    },
    edit($event) {
      this.activeCard = $event;
      this.dialogMode = "edit";
      this.dialog = true;
    },
    editCommit($event) {
      let items = this.items;
      let item = items.find((x) => x.id === $event.id);
      let indexOfItem = items.indexOf(item);
      this.$set(items, indexOfItem, item);
      this.closeDialog();
      this.$emit("autosave");
    },
    closeDialog() {
      this.dialogMode = "";
      this.activeCard = null;
      this.dialog = false;
      this.item = {};
      this.$set(this.item, {});
      this.$set(this.item, "matrix", []);
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        if (item) {
          let indexOfItem = this.items.indexOf(item);
          item.index = count;
          vm.$set(vm.items, indexOfItem, item);
        }
        count++;
      });
      this.dragging = false;
      this.$emit("autosave");
    },
  },
};
</script>

<style lang="scss" scoped>
.status-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 4px solid white;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  &--amber {
    border-color: rgb(243, 142, 2);
  }
  &--red {
    border-color: rgb(243, 14, 2);
  }
  &--green {
    border-color: rgb(47, 255, 0);
  }
}
.unit-items {
  .item {
    &--flex {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    padding: 0.5rem;
    margin: 0.5rem 0;
    background: rgb(38, 38, 38);
    border-radius: 5px;
    color: black;
    .icons {
      width: 50px;
      padding: 0 10px 0 10px;
      display: flex;
    }
  }
}
.unit-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
.no-bullets {
  list-style: none;
  margin: 0;
  padding: 0 0 0px 0px;
  li {
    padding: 3px 0;
    border-bottom: dotted 1px #333;
  }
}
</style>
